import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['María', 'Lucas', 'Sofía', 'Martín', 'Carolina', 'Diego', 'Valentina', 'Facundo'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Ushuaia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show every 15-30 seconds
    const interval = setInterval(() => {
      const randomDelay = 15000 + Math.random() * 15000; // 15-30 seconds
      setTimeout(showPopup, randomDelay);
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 bg-white rounded-lg shadow-2xl p-4 max-w-sm animate-slide-in-right z-40 border-2 border-green-500" data-id="element-333">
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-334">
        <XIcon className="w-4 h-4" data-id="element-335" />
      </button>
      <div className="flex items-start gap-3" data-id="element-336">
        <CheckCircleIcon className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-337" />
        <div data-id="element-338">
          <p className="font-bold text-gray-900 text-sm" data-id="element-339">
            {currentName} de {currentCity}
          </p>
          <p className="text-gray-600 text-sm mt-1" data-id="element-340">
            acaba de comprar el MEGAPACK
          </p>
        </div>
      </div>
    </div>;
}